import { City, Trade } from "@gigsync/protocol";
import { PILOT_AREAS } from "../estimate/areas.js";
import { FIELDS } from "../interview/card.js";
import { CLARIFY, MAX_CHOICES } from "./clarify.js";
import { allowedIntents } from "./intent.js";
const STRING = "string";
const enumOf = (values) => ({ type: STRING, enum: values });
export function replySchema(ctx) {
    const intents = allowedIntents(ctx);
    return {
        type: "object",
        properties: {
            intent: enumOf(ctx.mayAsk ? [...intents, CLARIFY] : intents),
            ...(ctx.mayAsk ? { options: { type: "array", items: enumOf(intents), maxItems: MAX_CHOICES } } : {}),
            trade: enumOf(Trade.options),
            area: enumOf(PILOT_AREAS.map((a) => a.key)),
            city: enumOf(City.options),
            amount: { type: "number" },
            ...(ctx.contacts.length > 0 ? { contact: enumOf(ctx.contacts) } : {}),
            field: enumOf(FIELDS),
            note: { type: STRING },
        },
        required: ["intent"],
        additionalProperties: false,
    };
}
//# sourceMappingURL=reply-schema.js.map